import { render } from "./ContactPersonInfo.vue?vue&type=template&id=c3af0c4a"
import script from "./ContactPersonInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactPersonInfo.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/start/ContactPersonInfo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c3af0c4a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c3af0c4a', __exports__)) {
    api.reload('c3af0c4a', __exports__)
  }
  
  module.hot.accept("./ContactPersonInfo.vue?vue&type=template&id=c3af0c4a", () => {
    api.rerender('c3af0c4a', render)
  })

}


export default __exports__